// Sample Tracker · Project Tracker · Ticket Station (15_SampleTracker.jsx) — the strings that were still written
// straight into the screen, in the portal's four languages (2026-10-21). The screen's older strings stay under `st.`.
// Stored values (statuses, stages, outcomes, round labels, "Not started" in the assignee column) are NOT here: they
// are data, compared by the code and printed as stored.
const en = {
  launchPast: '{{month}} has already passed. Pick this month or later.',
  launchMismatch: '{{month}} is outside the usual launch window for {{season}} ({{from}} – {{to}}). Is the year right?',
  launchConfirmBox: 'Yes, this Target Launching is right',
  requestFailed: 'Request failed ({{status}})',
  loadFailed: 'Failed to load Sample Tracker ({{status}})',
  loadTicketsFailed: 'Failed to load tickets ({{status}})',
  saveFailed: 'Save failed ({{status}})',
  saveFailedPlain: 'Save failed',
  deleteFailed: 'Delete failed ({{status}})',
  deleteFailedPlain: 'Delete failed',
  cannotDelete: 'Cannot delete ({{status}})',
  renameFailed: 'Rename failed ({{status}})',
  sendFailed: 'Send failed ({{status}})',
  exportFailed: 'Export failed ({{status}})',
  exportFailedPlain: 'Export failed',
  preparingExport: 'Preparing Excel export...',
  saving: 'Saving...',
  auto: '(auto)',
  noneSelected: 'None selected',
  noOptions: 'No options',

  stageLateHint: 'Target date has passed and this stage is still open',
  costingFromQuote: 'From Collab Pricing quote {{id}} — open it',
  pickDate: 'Pick a date',
  targetDate: 'Target date',
  clearToPending: 'Clear (back to Pending)',
  pickMonth: 'Pick a month',
  prevYear: 'Previous year',
  year: 'Year',
  nextYear: 'Next year',
  monShort: {
    m01: 'Jan', m02: 'Feb', m03: 'Mar', m04: 'Apr', m05: 'May', m06: 'Jun',
    m07: 'Jul', m08: 'Aug', m09: 'Sep', m10: 'Oct', m11: 'Nov', m12: 'Dec',
  },
  monLong: {
    m01: 'January', m02: 'February', m03: 'March', m04: 'April', m05: 'May', m06: 'June',
    m07: 'July', m08: 'August', m09: 'September', m10: 'October', m11: 'November', m12: 'December',
  },

  v: {
    projectName: 'Project name is required',
    required: '{{label}} is required',
    team: 'Team is required',
    category: 'Category is required',
    year: 'Year is required',
    maxSeasons: 'Pick at most two seasons',
    owner: 'Project Owner (Sales OP) is required',
    salesRep: 'Sales Rep. is required',
    purpose: 'Project Purpose is required',
    targetLaunch: 'Target Launching (month) is required',
    launchPast: 'Target Launching is before this month — pick this month or later.',
    launchConfirm: 'Target Launching does not fit the Year and Season — tick that it is right, or correct it.',
    skuItemName: 'SKU {{n}}: Item / SKU Name is required (or remove the card with x)',
    skuMissing_one: 'SKU {{n}}: {{fields}} is required',
    skuMissing_other: 'SKU {{n}}: {{fields}} are required',
    namedMissing_one: '{{name}}: {{fields}} is required',
    namedMissing_other: '{{name}}: {{fields}} are required',
    pickSample: 'Pick the sample this round belongs to — a round is always added to an existing sample',
    styleItem: 'Style / Item is required',
    round: 'Round is required',
    rmReady: 'RM Ready Date is required',
    devOrDesigner: 'A Developer or a Designer is required',
    reqDateInternal: 'Request Date is required for HEVN internal review',
    reviewDate: 'Review Date (Comment Date) is required when Outcome is {{outcome}}',
    remarksDropped: 'Remarks is required when Outcome is Dropped',
    reworkReason: 'At least one Rework Reason is required when Outcome is Rework',
    newBasePhoto: 'A new Base ID needs at least one photo of the sample',
    groupName: 'Group name is required.',
    projectId: 'Project ID is required',
    ticketType: 'Ticket Type is required',
    noOwner: '{{id}} has no Project Owner yet — open the project in Project Tracker (the pencil on its row), set Project Owner and save, then raise the ticket.',
    groupEmailSend: 'Group email is required when "Send email after saving" is checked',
    saveBeforeSend: 'Please save this ticket before sending email manually.',
    groupEmailBefore: 'Group email is required before sending.',
    recipient: 'An email recipient is required.',
  },
  skuReq: {
    estimateQty: 'Estimate QTY',
    exfShipDate: 'EXF Ship Date',
    targetPrice: 'Target Price',
    launchDate: 'Launching Date',
  },
  newSkuN: 'New SKU {{n}}',

  outcomeDesc: {
    advance: 'Advance - The current sample has been reviewed and approved to proceed to the next development round. A new round must be registered.',
    rework: 'Rework - The sample has been rejected and requires rework before the next review.',
    confirmed: 'Confirmed - The sample has been approved, and no further development rounds are required.',
    dropped: 'Dropped - Development for this style has been discontinued, and no further work will be carried out.',
    onHold: 'On Hold - The decision maker has not decided to go or no-go yet. Hold this round outcome until a decision is made.',
  },
  review: {
    done: 'Done',
    inReview: 'In review',
    waiting: 'Waiting 2 weeks+',
  },
  reviewChipDays: '{{label}} · last {{n}} days',
  flag: {
    costingPending: 'Costing pending',
    productionPending: 'Production pending',
    shipmentPending: 'Shipment pending',
    pastDue: 'Past due date',
    noSample: 'No sample yet',
  },
  lateChip: 'More than {{n}} days late',
  caseA: 'Case A - HPAC Direct Collaboration',
  caseB: 'Case B - Subsidiary-led Collaboration',

  stillNeeded: 'Still needed before this ticket can be sent: {{list}}',
  subjectPh: '[Project Name] - [Ticket Code] - [Ticket Name]',

  searchPartner: 'Search partner / line…',
  noMatch: 'No match for “{{q}}”',
  adding: 'Adding…',
  addTo: '+ Add “{{name}}” to {{list}}',
  theList: 'the list',
  salesRepList: 'the Sales Rep list',

  fillSeasonPartner: '— fill Season and Partner / Line —',
  fillSeason: '— fill Season —',
  nameManager: '{{name}} (manager)',
  salesRepLabel: 'Sales Rep.',
  searchSalesRep: 'Search or add a sales rep…',
  keywordPh: 'e.g. Chair One',
  notePh: 'Anything the approver should know — included in the approval request email',
  noSkuYet: 'No SKU yet — that is fine. A project can be created empty and the SKUs added later.',

  ofTotal: '{{label}} - of {{total}} total',
  projectFallback: 'Project',
  unassigned: '— unassigned —',

  editRound: 'Edit round',
  notMine: 'In {{name}}\'s name — designers and developers change only their own rounds. Ask your team manager to reassign it to you.',
  duplicateRound: 'Duplicate round',
  deleteRound: 'Delete round',
  addRound: 'Add round',
  editBase: 'Edit Base ID (photos, style name)',
  noRounds: 'No rounds to display',
  noData: 'No data to display',
  searchSample: 'Search sample...',
  showColumns: 'Show columns',
  showAll: 'Show all',
  prjItems_one: '{{count}} PRJ item',
  prjItems_other: '{{count}} PRJ items',
  editSkusOfProject: 'Edit the SKUs of this project',
  editGroup: 'Edit project group',
  ticketsForProject: 'Tickets for this project',
  deleteProjectAdmin: 'Delete this project and all its SKUs (admin)',
  createSampleFor: 'Create sample for this project',
  plusSample: '+ Sample',
  markComplete: 'Mark Complete and notify Production',
  complete: 'Complete',
  editSku: 'Edit this SKU',
  deleteProject: 'Delete project',
  noReplyEmailed: 'No reply yet — the receiving team has been emailed and has not answered.',
  noReplyNeverEmailed: 'No reply yet — this ticket has never been emailed, so nobody has been asked.',

  completeTitle: 'Complete {{id}} — notify Production',
  preparingEmail: 'Preparing the email…',
  to: 'To',
  subject: 'Subject',
  message: 'Message',
  completeNote: 'The status changes to <b>Complete</b> only when this email is sent. Cancel and nothing changes.',
  sending: 'Sending…',
  sendMarkComplete: 'Send & mark Complete',

  dupTitle: 'Possible duplicate',
  dupLead: 'A project with this <b>Season + Partner / Line</b> already exists:',
  dupHint: 'Parallel projects on the same partner and season do happen — this is a warning, not a block.',
  createAnyway: 'Create it anyway',

  msg: {
    deletingProject: 'Deleting project...',
    groupDeleted: '{{id}} deleted — {{skus}} SKU removed, {{rounds}} sample round(s) kept without a project',
    ticketsCancelled: ' · {{n}} ticket(s) cancelled',
    ticketsCancelledNotified: ' · {{n}} ticket(s) cancelled, {{m}} mailbox notified',
    advanceCancelled: 'Cancelled - {{id}} was NOT set to Advance and no new round was created',
    theRound: 'the round',
    photosAttached_one: ' — {{count}} photo attached to {{base}}',
    photosAttached_other: ' — {{count}} photos attached to {{base}}',
    theBaseId: 'the Base ID',
    advanceSaved: '{{from}} set to Advance and {{to}} created',
    roundUpdated: 'Round updated',
    roundAdded: 'Round added',
    renamed_one: '{{id}} renamed to "{{name}}" ({{count}} round)',
    renamed_other: '{{id}} renamed to "{{name}}" ({{count}} rounds)',
    confirmDeleteRound: 'Delete round {{id}}? This cannot be undone.',
    roundDeleted: 'Round deleted',
    addPartnerFailed: 'Failed to add partner',
    partnerAdded: 'Partner "{{name}}" added to the list',
    addSalesRepFailed: 'Failed to add the Sales Rep',
    salesRepAdded: 'Sales Rep "{{name}}" added to the list',
    mailSent: ' — approval request sent to {{to}}',
    mailFailed: ' — approval email FAILED ({{err}})',
    mailPending: ' — now in Pending Approval. It is NOT sent to the approver yet: open Project Approval and press Submit.',
    photosNotUploaded_one: ' — WARNING {{count}} photo not uploaded, add them on each SKU from Edit',
    photosNotUploaded_other: ' — WARNING {{count}} photos not uploaded, add them on each SKU from Edit',
    photosUploaded_one: ' — {{count}} photo uploaded',
    photosUploaded_other: ' — {{count}} photos uploaded',
    photosPartial: ' — WARNING only {{done}} of {{wanted}} photos uploaded, add the rest on the SKU',
    movedInApproved_one: ' · {{count}} approved SKU moved in — the project is Approved',
    movedInApproved_other: ' · {{count}} approved SKUs moved in — the project is Approved',
    notMovedRetry: ' — NOT moved: {{list}}. Open the project with Edit to try again.',
    newSkus_one: ' ({{count}} new SKU)',
    newSkus_other: ' ({{count}} new SKUs)',
    createdPending: '{{id}} created as Pending Approval',
    created: '{{id}} created',
    newTicketN: 'the new ticket #{{n}}',
    removeSkuFailed: 'Failed to remove SKU from group',
    skuRemovedFrom: '{{id}} removed from {{group}}',
    ticketWord: 'ticket',
    ticketsEmailed: ' · {{n}} ticket emailed',
    emailNotSent: ' · EMAIL NOT SENT — {{list}}',
    createTicketFailed: 'Failed to create ticket {{code}}',
    ticketsAddedTo_one: '{{count}} ticket added to {{id}}',
    ticketsAddedTo_other: '{{count}} tickets added to {{id}}',
    noNewTicket: 'No new ticket to add',
    refusedBefore: 'This save was refused before anything was written.',
    updateFailed: 'Failed to update {{id}}',
    updateTicketFailed: 'Failed to update ticket {{id}}',
    addSkuFailed: 'Failed to add SKU',
    skuMovedIn: ' · {{n}} SKU moved in',
    notMoved: ' — NOT moved: {{list}}',
    groupUpdated: 'Group updated',
    skusUpdated: ' · {{n}} SKU updated',
    ticketsUpdated: ' · {{n}} ticket updated',
    skusAdded: ' · {{n}} SKU added',
    ticketsAdded: ' · {{n}} ticket added',
    previewFailed: 'Could not build the preview',
    completeOpenFailed: 'Could not open the Complete dialog: {{err}}',
    completeFailed: 'Could not complete the project',
    completed: '{{id}} marked Complete — email sent to {{to}}',
    exportedProjects: 'Excel exported — {{groups}} projects, {{skus}} SKUs',
    exportedTickets: 'Excel exported — {{n}} tickets',
    exported: 'Excel exported',
    noRowsExport: 'No rows to export',
    projectUpdated: 'Project updated',
    projectAdded: 'Project added',
    createGroupFailed: 'Failed to create group',
    confirmDeleteProject: 'Delete project {{id}}? This cannot be undone.',
    projectDeleted: 'Project deleted',
    ticketSavedMailFailed: 'Ticket saved, but email failed: {{err}}',
    ticketSavedSent: 'Ticket saved and email sent',
    ticketSaved: 'Ticket saved',
    ticketDeletedNotified: '{{id}} deleted — cancellation notice sent to {{to}}',
    ticketDeletedMailFailed: '{{id}} deleted — WARNING the cancellation email failed, tell them by hand',
    ticketDeletedNeverEmailed: '{{id}} deleted (it had never been emailed, so nobody was notified)',
    reminderSentTo: 'Reminder sent to {{to}}',
    emailSent: 'Email sent',
    remindFailedPlain: 'Could not send the reminder',
    reminderFor: 'Reminder for {{id}} sent to {{to}}.',
    reminderFailed: 'Reminder failed: {{err}}',
    sendTicketFailed: 'Could not send the ticket email',
  },

  // The Excel files the screen sends to be built — export only, nothing reads them back.
  xls: {
    titleProjects: 'Helinox - Project Tracker',
    titleTickets: 'Helinox - Ticket Station',
    titleSamples: 'Helinox - All Samples',
    status: 'Status: {{v}}',
    team: 'Team: {{v}}',
    owner: 'Owner: {{v}}',
    developer: 'Developer: {{v}}',
    designer: 'Designer: {{v}}',
    salesRep: 'Sales Rep: {{v}}',
    search: 'Search: {{v}}',
    card: 'Card: {{v}}',
    requester: 'Requester: {{v}}',
    sopTeam: 'Sales OP team: {{v}}',
    receivingTeam: 'Receiving team: {{v}}',
    priority: 'Priority: {{v}}',
    sample: 'Sample: {{v}}',
    round: 'Round: {{v}}',
    location: 'Location: {{v}}',
    allLocations: 'All Locations',
    sampleFinish: 'Sample Finish',
    qty: 'QTY',
  },
};

const ko = {
  launchPast: '{{month}}은(는) 이미 지났습니다. 이번 달 이후로 선택하세요.',
  launchMismatch: '{{month}}은(는) {{season}}의 일반적인 출시 기간({{from}} – {{to}})을 벗어납니다. 연도가 맞나요?',
  launchConfirmBox: '네, 이 목표 출시 월이 맞습니다',
  requestFailed: '요청 실패 ({{status}})',
  loadFailed: '샘플 트래커를 불러오지 못했습니다 ({{status}})',
  loadTicketsFailed: '티켓을 불러오지 못했습니다 ({{status}})',
  saveFailed: '저장 실패 ({{status}})',
  saveFailedPlain: '저장 실패',
  deleteFailed: '삭제 실패 ({{status}})',
  deleteFailedPlain: '삭제 실패',
  cannotDelete: '삭제할 수 없습니다 ({{status}})',
  renameFailed: '이름 변경 실패 ({{status}})',
  sendFailed: '발송 실패 ({{status}})',
  exportFailed: '내보내기 실패 ({{status}})',
  exportFailedPlain: '내보내기 실패',
  preparingExport: 'Excel 내보내기 준비 중...',
  saving: '저장 중...',
  auto: '(자동)',
  noneSelected: '선택 없음',
  noOptions: '항목 없음',

  stageLateHint: '목표일이 지났지만 이 단계가 아직 끝나지 않았습니다',
  costingFromQuote: 'Collab Pricing 견적 {{id}}에서 가져옴 — 열기',
  pickDate: '날짜 선택',
  targetDate: '목표일',
  clearToPending: '지우기 (Pending으로)',
  pickMonth: '월 선택',
  prevYear: '이전 연도',
  year: '연도',
  nextYear: '다음 연도',
  monShort: {
    m01: '1월', m02: '2월', m03: '3월', m04: '4월', m05: '5월', m06: '6월',
    m07: '7월', m08: '8월', m09: '9월', m10: '10월', m11: '11월', m12: '12월',
  },
  monLong: {
    m01: '1월', m02: '2월', m03: '3월', m04: '4월', m05: '5월', m06: '6월',
    m07: '7월', m08: '8월', m09: '9월', m10: '10월', m11: '11월', m12: '12월',
  },

  v: {
    projectName: '프로젝트 이름은 필수입니다',
    required: '{{label}}은(는) 필수입니다',
    team: '팀은 필수입니다',
    category: '카테고리는 필수입니다',
    year: '연도는 필수입니다',
    maxSeasons: '시즌은 최대 두 개까지 고를 수 있습니다',
    owner: '프로젝트 오너(Sales OP)는 필수입니다',
    salesRep: 'Sales Rep.은 필수입니다',
    purpose: '프로젝트 목적은 필수입니다',
    targetLaunch: '목표 출시(월)는 필수입니다',
    launchPast: '목표 출시가 이번 달보다 이전입니다 — 이번 달 이후로 선택하세요.',
    launchConfirm: '목표 출시가 연도·시즌과 맞지 않습니다 — 맞다면 체크하고, 아니면 수정하세요.',
    skuItemName: 'SKU {{n}}: 아이템 / SKU 명은 필수입니다 (또는 x로 카드를 제거하세요)',
    skuMissing_one: 'SKU {{n}}: {{fields}}은(는) 필수입니다',
    skuMissing_other: 'SKU {{n}}: {{fields}}은(는) 필수입니다',
    namedMissing_one: '{{name}}: {{fields}}은(는) 필수입니다',
    namedMissing_other: '{{name}}: {{fields}}은(는) 필수입니다',
    pickSample: '이 라운드가 속할 샘플을 고르세요 — 라운드는 항상 기존 샘플에 추가됩니다',
    styleItem: '스타일 / 품목은 필수입니다',
    round: '라운드는 필수입니다',
    rmReady: '원자재 준비일은 필수입니다',
    devOrDesigner: '개발자 또는 디자이너 중 한 명은 필수입니다',
    reqDateInternal: 'HEVN 내부 검토에는 요청일이 필수입니다',
    reviewDate: '결과가 {{outcome}}이면 검토일(코멘트일)이 필수입니다',
    remarksDropped: '결과가 Dropped이면 비고는 필수입니다',
    reworkReason: '결과가 Rework이면 재작업 사유를 하나 이상 선택해야 합니다',
    newBasePhoto: '새 Base ID에는 샘플 사진이 한 장 이상 필요합니다',
    groupName: '그룹 이름은 필수입니다.',
    projectId: '프로젝트 ID는 필수입니다',
    ticketType: '티켓 유형은 필수입니다',
    noOwner: '{{id}}에 아직 프로젝트 오너가 없습니다 — 프로젝트 트래커에서 프로젝트를 열고(행의 연필 아이콘) 프로젝트 오너를 지정해 저장한 뒤 티켓을 발행하세요.',
    groupEmailSend: '"저장 후 이메일 발송"을 체크하면 그룹 이메일이 필요합니다',
    saveBeforeSend: '이메일을 직접 보내기 전에 먼저 이 티켓을 저장하세요.',
    groupEmailBefore: '발송하기 전에 그룹 이메일이 필요합니다.',
    recipient: '이메일 수신자가 필요합니다.',
  },
  skuReq: {
    estimateQty: '예상 수량',
    exfShipDate: 'EXF 선적일',
    targetPrice: '목표 가격',
    launchDate: '출시일',
  },
  newSkuN: '새 SKU {{n}}',

  outcomeDesc: {
    advance: 'Advance - 현재 샘플이 검토를 거쳐 다음 개발 라운드로 진행하도록 승인되었습니다. 새 라운드를 등록해야 합니다.',
    rework: 'Rework - 샘플이 반려되어 다음 검토 전에 재작업이 필요합니다.',
    confirmed: 'Confirmed - 샘플이 승인되었으며 더 이상의 개발 라운드는 필요하지 않습니다.',
    dropped: 'Dropped - 이 스타일의 개발이 중단되었으며 더 이상 작업하지 않습니다.',
    onHold: 'On Hold - 의사결정자가 진행 여부를 아직 결정하지 않았습니다. 결정이 날 때까지 이 라운드 결과를 보류합니다.',
  },
  review: {
    done: '완료',
    inReview: '검토 중',
    waiting: '2주 이상 대기',
  },
  reviewChipDays: '{{label}} · 최근 {{n}}일',
  flag: {
    costingPending: '원가 산출 대기',
    productionPending: '생산 대기',
    shipmentPending: '선적 대기',
    pastDue: '기한 경과',
    noSample: '샘플 없음',
  },
  lateChip: '{{n}}일 넘게 지연',
  caseA: '케이스 A - HPAC 직접 협업',
  caseB: '케이스 B - 자회사 주도 협업',

  stillNeeded: '이 티켓을 보내기 전에 채워야 할 항목: {{list}}',
  subjectPh: '[프로젝트명] - [티켓 코드] - [티켓명]',

  searchPartner: '파트너 / 라인 검색…',
  noMatch: '“{{q}}”와(과) 일치하는 항목이 없습니다',
  adding: '추가 중…',
  addTo: '+ “{{name}}”을(를) {{list}}에 추가',
  theList: '목록',
  salesRepList: 'Sales Rep 목록',

  fillSeasonPartner: '— 시즌과 파트너 / 라인을 입력하세요 —',
  fillSeason: '— 시즌을 입력하세요 —',
  nameManager: '{{name}} (매니저)',
  salesRepLabel: 'Sales Rep.',
  searchSalesRep: 'Sales Rep 검색 또는 추가…',
  keywordPh: '예: Chair One',
  notePh: '승인자가 알아야 할 내용 — 승인 요청 메일에 포함됩니다',
  noSkuYet: '아직 SKU가 없습니다 — 괜찮습니다. 프로젝트는 비어 있는 상태로 만들고 SKU는 나중에 추가할 수 있습니다.',

  ofTotal: '{{label}} - 전체 {{total}}개 중',
  projectFallback: '프로젝트',
  unassigned: '— 미지정 —',

  editRound: '라운드 수정',
  notMine: '{{name}} 담당 라운드입니다 — 디자이너와 개발자는 본인 라운드만 수정할 수 있습니다. 팀 매니저에게 담당자 변경을 요청하세요.',
  duplicateRound: '라운드 복제',
  deleteRound: '라운드 삭제',
  addRound: '라운드 추가',
  editBase: 'Base ID 수정 (사진, 스타일명)',
  noRounds: '표시할 라운드가 없습니다',
  noData: '표시할 데이터가 없습니다',
  searchSample: '샘플 검색...',
  showColumns: '표시할 열',
  showAll: '모두 표시',
  prjItems_one: 'PRJ 항목 {{count}}개',
  prjItems_other: 'PRJ 항목 {{count}}개',
  editSkusOfProject: '이 프로젝트의 SKU 수정',
  editGroup: '프로젝트 그룹 수정',
  ticketsForProject: '이 프로젝트의 티켓',
  deleteProjectAdmin: '이 프로젝트와 모든 SKU 삭제 (관리자)',
  createSampleFor: '이 프로젝트의 샘플 만들기',
  plusSample: '+ 샘플',
  markComplete: '완료 처리하고 생산팀에 알림',
  complete: '완료',
  editSku: '이 SKU 수정',
  deleteProject: '프로젝트 삭제',
  noReplyEmailed: '아직 회신 없음 — 수신 팀에 메일을 보냈지만 답이 없습니다.',
  noReplyNeverEmailed: '아직 회신 없음 — 이 티켓은 메일을 보낸 적이 없어 누구에게도 요청되지 않았습니다.',

  completeTitle: '{{id}} 완료 — 생산팀에 알림',
  preparingEmail: '메일 준비 중…',
  to: '받는 사람',
  subject: '제목',
  message: '메시지',
  completeNote: '이 메일이 발송될 때에만 상태가 <b>Complete</b>로 바뀝니다. 취소하면 아무것도 바뀌지 않습니다.',
  sending: '발송 중…',
  sendMarkComplete: '발송하고 완료 처리',

  dupTitle: '중복 가능성',
  dupLead: '같은 <b>시즌 + 파트너 / 라인</b>의 프로젝트가 이미 있습니다:',
  dupHint: '같은 파트너·시즌으로 프로젝트가 병행되는 경우도 있습니다 — 경고일 뿐 막지는 않습니다.',
  createAnyway: '그래도 만들기',

  msg: {
    deletingProject: '프로젝트 삭제 중...',
    groupDeleted: '{{id}} 삭제됨 — SKU {{skus}}개 제거, 샘플 라운드 {{rounds}}개는 프로젝트 없이 유지',
    ticketsCancelled: ' · 티켓 {{n}}개 취소',
    ticketsCancelledNotified: ' · 티켓 {{n}}개 취소, 메일함 {{m}}곳에 알림',
    advanceCancelled: '취소됨 - {{id}}은(는) Advance로 설정되지 않았고 새 라운드도 만들어지지 않았습니다',
    theRound: '해당 라운드',
    photosAttached_one: ' — 사진 {{count}}장을 {{base}}에 첨부',
    photosAttached_other: ' — 사진 {{count}}장을 {{base}}에 첨부',
    theBaseId: 'Base ID',
    advanceSaved: '{{from}}을(를) Advance로 설정하고 {{to}}을(를) 만들었습니다',
    roundUpdated: '라운드를 수정했습니다',
    roundAdded: '라운드를 추가했습니다',
    renamed_one: '{{id}}의 이름을 "{{name}}"(으)로 변경했습니다 (라운드 {{count}}개)',
    renamed_other: '{{id}}의 이름을 "{{name}}"(으)로 변경했습니다 (라운드 {{count}}개)',
    confirmDeleteRound: '라운드 {{id}}을(를) 삭제할까요? 되돌릴 수 없습니다.',
    roundDeleted: '라운드를 삭제했습니다',
    addPartnerFailed: '파트너를 추가하지 못했습니다',
    partnerAdded: '파트너 "{{name}}"을(를) 목록에 추가했습니다',
    addSalesRepFailed: 'Sales Rep을 추가하지 못했습니다',
    salesRepAdded: 'Sales Rep "{{name}}"을(를) 목록에 추가했습니다',
    mailSent: ' — 승인 요청을 {{to}}에게 보냈습니다',
    mailFailed: ' — 승인 메일 발송 실패 ({{err}})',
    mailPending: ' — 이제 승인 대기 상태입니다. 아직 승인자에게 보내지 않았습니다: 프로젝트 승인 화면에서 Submit을 누르세요.',
    photosNotUploaded_one: ' — 경고: 사진 {{count}}장이 업로드되지 않았습니다. 수정 화면에서 각 SKU에 추가하세요',
    photosNotUploaded_other: ' — 경고: 사진 {{count}}장이 업로드되지 않았습니다. 수정 화면에서 각 SKU에 추가하세요',
    photosUploaded_one: ' — 사진 {{count}}장 업로드',
    photosUploaded_other: ' — 사진 {{count}}장 업로드',
    photosPartial: ' — 경고: 사진 {{wanted}}장 중 {{done}}장만 업로드되었습니다. 나머지는 SKU에 추가하세요',
    movedInApproved_one: ' · 승인된 SKU {{count}}개를 옮겨 왔습니다 — 프로젝트가 승인 상태입니다',
    movedInApproved_other: ' · 승인된 SKU {{count}}개를 옮겨 왔습니다 — 프로젝트가 승인 상태입니다',
    notMovedRetry: ' — 옮기지 못함: {{list}}. 수정으로 프로젝트를 열어 다시 시도하세요.',
    newSkus_one: ' (새 SKU {{count}}개)',
    newSkus_other: ' (새 SKU {{count}}개)',
    createdPending: '{{id}}을(를) 승인 대기 상태로 만들었습니다',
    created: '{{id}}을(를) 만들었습니다',
    newTicketN: '새 티켓 #{{n}}',
    removeSkuFailed: '그룹에서 SKU를 제거하지 못했습니다',
    skuRemovedFrom: '{{id}}을(를) {{group}}에서 제거했습니다',
    ticketWord: '티켓',
    ticketsEmailed: ' · 티켓 {{n}}개 메일 발송',
    emailNotSent: ' · 메일 발송 안 됨 — {{list}}',
    createTicketFailed: '티켓 {{code}}을(를) 만들지 못했습니다',
    ticketsAddedTo_one: '{{id}}에 티켓 {{count}}개를 추가했습니다',
    ticketsAddedTo_other: '{{id}}에 티켓 {{count}}개를 추가했습니다',
    noNewTicket: '추가할 새 티켓이 없습니다',
    refusedBefore: '저장이 거부되어 아무것도 기록되지 않았습니다.',
    updateFailed: '{{id}}을(를) 수정하지 못했습니다',
    updateTicketFailed: '티켓 {{id}}을(를) 수정하지 못했습니다',
    addSkuFailed: 'SKU를 추가하지 못했습니다',
    skuMovedIn: ' · SKU {{n}}개 이동',
    notMoved: ' — 옮기지 못함: {{list}}',
    groupUpdated: '그룹을 수정했습니다',
    skusUpdated: ' · SKU {{n}}개 수정',
    ticketsUpdated: ' · 티켓 {{n}}개 수정',
    skusAdded: ' · SKU {{n}}개 추가',
    ticketsAdded: ' · 티켓 {{n}}개 추가',
    previewFailed: '미리보기를 만들 수 없습니다',
    completeOpenFailed: '완료 창을 열 수 없습니다: {{err}}',
    completeFailed: '프로젝트를 완료 처리하지 못했습니다',
    completed: '{{id}} 완료 처리 — {{to}}에게 메일 발송',
    exportedProjects: 'Excel 내보내기 완료 — 프로젝트 {{groups}}개, SKU {{skus}}개',
    exportedTickets: 'Excel 내보내기 완료 — 티켓 {{n}}개',
    exported: 'Excel 내보내기 완료',
    noRowsExport: '내보낼 행이 없습니다',
    projectUpdated: '프로젝트를 수정했습니다',
    projectAdded: '프로젝트를 추가했습니다',
    createGroupFailed: '그룹을 만들지 못했습니다',
    confirmDeleteProject: '프로젝트 {{id}}을(를) 삭제할까요? 되돌릴 수 없습니다.',
    projectDeleted: '프로젝트를 삭제했습니다',
    ticketSavedMailFailed: '티켓은 저장했지만 메일 발송에 실패했습니다: {{err}}',
    ticketSavedSent: '티켓을 저장하고 메일을 보냈습니다',
    ticketSaved: '티켓을 저장했습니다',
    ticketDeletedNotified: '{{id}} 삭제됨 — 취소 알림을 {{to}}에게 보냈습니다',
    ticketDeletedMailFailed: '{{id}} 삭제됨 — 경고: 취소 메일 발송에 실패했습니다. 직접 알려 주세요',
    ticketDeletedNeverEmailed: '{{id}} 삭제됨 (메일을 보낸 적이 없어 아무에게도 알리지 않았습니다)',
    reminderSentTo: '{{to}}에게 리마인더를 보냈습니다',
    emailSent: '메일을 보냈습니다',
    remindFailedPlain: '리마인더를 보내지 못했습니다',
    reminderFor: '{{id}} 리마인더를 {{to}}에게 보냈습니다.',
    reminderFailed: '리마인더 발송 실패: {{err}}',
    sendTicketFailed: '티켓 메일을 보내지 못했습니다',
  },

  xls: {
    titleProjects: 'Helinox - 프로젝트 트래커',
    titleTickets: 'Helinox - 티켓 스테이션',
    titleSamples: 'Helinox - 전체 샘플',
    status: '상태: {{v}}',
    team: '팀: {{v}}',
    owner: '오너: {{v}}',
    developer: '개발자: {{v}}',
    designer: '디자이너: {{v}}',
    salesRep: 'Sales Rep: {{v}}',
    search: '검색: {{v}}',
    card: '카드: {{v}}',
    requester: '요청자: {{v}}',
    sopTeam: 'Sales OP 팀: {{v}}',
    receivingTeam: '수신 팀: {{v}}',
    priority: '우선순위: {{v}}',
    sample: '샘플: {{v}}',
    round: '라운드: {{v}}',
    location: '위치: {{v}}',
    allLocations: '전체 위치',
    sampleFinish: '샘플 완료',
    qty: '수량',
  },
};

const vi = {
  launchPast: '{{month}} đã qua. Chọn tháng này hoặc sau đó.',
  launchMismatch: '{{month}} nằm ngoài khoảng ra mắt thường thấy của {{season}} ({{from}} – {{to}}). Năm có đúng không?',
  launchConfirmBox: 'Đúng, tháng ra mắt này là chính xác',
  requestFailed: 'Yêu cầu không thành công ({{status}})',
  loadFailed: 'Không tải được Theo dõi mẫu ({{status}})',
  loadTicketsFailed: 'Không tải được ticket ({{status}})',
  saveFailed: 'Lưu không thành công ({{status}})',
  saveFailedPlain: 'Lưu không thành công',
  deleteFailed: 'Xóa không thành công ({{status}})',
  deleteFailedPlain: 'Xóa không thành công',
  cannotDelete: 'Không thể xóa ({{status}})',
  renameFailed: 'Đổi tên không thành công ({{status}})',
  sendFailed: 'Gửi không thành công ({{status}})',
  exportFailed: 'Xuất không thành công ({{status}})',
  exportFailedPlain: 'Xuất không thành công',
  preparingExport: 'Đang chuẩn bị xuất Excel...',
  saving: 'Đang lưu...',
  auto: '(tự động)',
  noneSelected: 'Chưa chọn mục nào',
  noOptions: 'Không có lựa chọn',

  stageLateHint: 'Đã quá ngày mục tiêu mà giai đoạn này vẫn chưa xong',
  costingFromQuote: 'Lấy từ báo giá Collab Pricing {{id}} — bấm để mở',
  pickDate: 'Chọn ngày',
  targetDate: 'Ngày mục tiêu',
  clearToPending: 'Xóa (về Pending)',
  pickMonth: 'Chọn tháng',
  prevYear: 'Năm trước',
  year: 'Năm',
  nextYear: 'Năm sau',
  monShort: {
    m01: 'Th1', m02: 'Th2', m03: 'Th3', m04: 'Th4', m05: 'Th5', m06: 'Th6',
    m07: 'Th7', m08: 'Th8', m09: 'Th9', m10: 'Th10', m11: 'Th11', m12: 'Th12',
  },
  monLong: {
    m01: 'Tháng 1', m02: 'Tháng 2', m03: 'Tháng 3', m04: 'Tháng 4', m05: 'Tháng 5', m06: 'Tháng 6',
    m07: 'Tháng 7', m08: 'Tháng 8', m09: 'Tháng 9', m10: 'Tháng 10', m11: 'Tháng 11', m12: 'Tháng 12',
  },

  v: {
    projectName: 'Bắt buộc nhập tên dự án',
    required: 'Bắt buộc nhập {{label}}',
    team: 'Bắt buộc chọn nhóm',
    category: 'Bắt buộc chọn danh mục',
    year: 'Bắt buộc chọn năm',
    maxSeasons: 'Chỉ chọn tối đa hai mùa',
    owner: 'Bắt buộc chọn Chủ dự án (Sales OP)',
    salesRep: 'Bắt buộc chọn Sales Rep.',
    purpose: 'Bắt buộc nhập Mục đích dự án',
    targetLaunch: 'Bắt buộc chọn Tháng ra mắt dự kiến',
    launchPast: 'Tháng ra mắt dự kiến đã qua — chọn tháng này hoặc sau đó.',
    launchConfirm: 'Tháng ra mắt dự kiến không khớp Năm và Mùa — tick xác nhận là đúng, hoặc sửa lại.',
    skuItemName: 'SKU {{n}}: bắt buộc nhập Tên mặt hàng / SKU (hoặc bỏ thẻ bằng nút x)',
    skuMissing_one: 'SKU {{n}}: bắt buộc nhập {{fields}}',
    skuMissing_other: 'SKU {{n}}: bắt buộc nhập {{fields}}',
    namedMissing_one: '{{name}}: bắt buộc nhập {{fields}}',
    namedMissing_other: '{{name}}: bắt buộc nhập {{fields}}',
    pickSample: 'Chọn mẫu mà vòng này thuộc về — một vòng luôn được thêm vào một mẫu đã có',
    styleItem: 'Bắt buộc có Style / Mặt hàng',
    round: 'Bắt buộc chọn vòng',
    rmReady: 'Bắt buộc nhập Ngày RM sẵn sàng',
    devOrDesigner: 'Bắt buộc có Developer hoặc Designer',
    reqDateInternal: 'Đánh giá nội bộ HEVN bắt buộc có Ngày yêu cầu',
    reviewDate: 'Khi Kết quả là {{outcome}}, bắt buộc có Ngày đánh giá (Ngày nhận xét)',
    remarksDropped: 'Khi Kết quả là Dropped, bắt buộc nhập Ghi chú',
    reworkReason: 'Khi Kết quả là Rework, phải chọn ít nhất một Lý do làm lại',
    newBasePhoto: 'Base ID mới cần ít nhất một ảnh mẫu',
    groupName: 'Bắt buộc nhập tên nhóm.',
    projectId: 'Bắt buộc chọn mã dự án',
    ticketType: 'Bắt buộc chọn loại ticket',
    noOwner: '{{id}} chưa có Chủ dự án — mở dự án trong Theo dõi dự án (biểu tượng bút chì trên dòng), chọn Chủ dự án và lưu, rồi tạo ticket.',
    groupEmailSend: 'Cần email nhóm khi đã chọn "Gửi email sau khi lưu"',
    saveBeforeSend: 'Hãy lưu ticket này trước khi gửi email thủ công.',
    groupEmailBefore: 'Cần email nhóm trước khi gửi.',
    recipient: 'Cần có người nhận email.',
  },
  skuReq: {
    estimateQty: 'SL dự kiến',
    exfShipDate: 'Ngày giao EXF',
    targetPrice: 'Giá mục tiêu',
    launchDate: 'Ngày ra mắt',
  },
  newSkuN: 'SKU mới {{n}}',

  outcomeDesc: {
    advance: 'Advance - Mẫu hiện tại đã được xem xét và được duyệt để chuyển sang vòng phát triển tiếp theo. Cần tạo một vòng mới.',
    rework: 'Rework - Mẫu bị từ chối và cần làm lại trước lần xem xét tiếp theo.',
    confirmed: 'Confirmed - Mẫu đã được duyệt, không cần thêm vòng phát triển nào nữa.',
    dropped: 'Dropped - Việc phát triển style này đã dừng, sẽ không làm thêm gì nữa.',
    onHold: 'On Hold - Người quyết định chưa chốt làm hay không. Giữ kết quả vòng này cho đến khi có quyết định.',
  },
  review: {
    done: 'Xong',
    inReview: 'Đang xem xét',
    waiting: 'Chờ hơn 2 tuần',
  },
  reviewChipDays: '{{label}} · {{n}} ngày gần nhất',
  flag: {
    costingPending: 'Tính giá đang chờ',
    productionPending: 'Sản xuất đang chờ',
    shipmentPending: 'Giao hàng đang chờ',
    pastDue: 'Quá hạn',
    noSample: 'Chưa có mẫu',
  },
  lateChip: 'Trễ hơn {{n}} ngày',
  caseA: 'Trường hợp A - Hợp tác trực tiếp với HPAC',
  caseB: 'Trường hợp B - Hợp tác do công ty con dẫn dắt',

  stillNeeded: 'Cần điền trước khi gửi ticket này: {{list}}',
  subjectPh: '[Tên dự án] - [Mã ticket] - [Tên ticket]',

  searchPartner: 'Tìm đối tác / dòng sản phẩm…',
  noMatch: 'Không có kết quả cho “{{q}}”',
  adding: 'Đang thêm…',
  addTo: '+ Thêm “{{name}}” vào {{list}}',
  theList: 'danh sách',
  salesRepList: 'danh sách Sales Rep',

  fillSeasonPartner: '— điền Mùa và Đối tác / Dòng sản phẩm —',
  fillSeason: '— điền Mùa —',
  nameManager: '{{name}} (quản lý)',
  salesRepLabel: 'Sales Rep.',
  searchSalesRep: 'Tìm hoặc thêm sales rep…',
  keywordPh: 'VD: Chair One',
  notePh: 'Những điều người duyệt cần biết — sẽ có trong email yêu cầu duyệt',
  noSkuYet: 'Chưa có SKU — không sao. Có thể tạo dự án trống và thêm SKU sau.',

  ofTotal: '{{label}} - trên tổng {{total}}',
  projectFallback: 'Dự án',
  unassigned: '— chưa giao —',

  editRound: 'Sửa vòng',
  notMine: 'Vòng này đứng tên {{name}} — designer và developer chỉ sửa được vòng của mình. Nhờ manager của team chuyển sang tên bạn trước.',
  duplicateRound: 'Nhân bản vòng',
  deleteRound: 'Xóa vòng',
  addRound: 'Thêm vòng',
  editBase: 'Sửa Base ID (ảnh, tên style)',
  noRounds: 'Không có vòng nào để hiển thị',
  noData: 'Không có dữ liệu để hiển thị',
  searchSample: 'Tìm mẫu...',
  showColumns: 'Hiện cột',
  showAll: 'Hiện tất cả',
  prjItems_one: '{{count}} mục PRJ',
  prjItems_other: '{{count}} mục PRJ',
  editSkusOfProject: 'Sửa các SKU của dự án này',
  editGroup: 'Sửa nhóm dự án',
  ticketsForProject: 'Ticket của dự án này',
  deleteProjectAdmin: 'Xóa dự án này và mọi SKU của nó (admin)',
  createSampleFor: 'Tạo mẫu cho dự án này',
  plusSample: '+ Mẫu',
  markComplete: 'Đánh dấu Hoàn thành và báo bộ phận Sản xuất',
  complete: 'Hoàn thành',
  editSku: 'Sửa SKU này',
  deleteProject: 'Xóa dự án',
  noReplyEmailed: 'Chưa có phản hồi — đã gửi email cho bộ phận nhận nhưng họ chưa trả lời.',
  noReplyNeverEmailed: 'Chưa có phản hồi — ticket này chưa từng được gửi email nên chưa ai được hỏi.',

  completeTitle: 'Hoàn thành {{id}} — báo bộ phận Sản xuất',
  preparingEmail: 'Đang chuẩn bị email…',
  to: 'Đến',
  subject: 'Tiêu đề',
  message: 'Nội dung',
  completeNote: 'Trạng thái chỉ chuyển sang <b>Complete</b> khi email này được gửi. Bấm Hủy thì không có gì thay đổi.',
  sending: 'Đang gửi…',
  sendMarkComplete: 'Gửi & đánh dấu Hoàn thành',

  dupTitle: 'Có thể bị trùng',
  dupLead: 'Đã có dự án với cùng <b>Mùa + Đối tác / Dòng sản phẩm</b>:',
  dupHint: 'Nhiều dự án song song với cùng đối tác và mùa vẫn có thể xảy ra — đây là cảnh báo, không phải chặn.',
  createAnyway: 'Vẫn tạo',

  msg: {
    deletingProject: 'Đang xóa dự án...',
    groupDeleted: '{{id}} đã xóa — đã bỏ {{skus}} SKU, giữ lại {{rounds}} vòng mẫu không gắn dự án',
    ticketsCancelled: ' · đã hủy {{n}} ticket',
    ticketsCancelledNotified: ' · đã hủy {{n}} ticket, đã báo {{m}} hộp thư',
    advanceCancelled: 'Đã hủy - {{id}} KHÔNG được chuyển sang Advance và không có vòng mới nào được tạo',
    theRound: 'vòng này',
    photosAttached_one: ' — đã đính kèm {{count}} ảnh vào {{base}}',
    photosAttached_other: ' — đã đính kèm {{count}} ảnh vào {{base}}',
    theBaseId: 'Base ID',
    advanceSaved: '{{from}} đã chuyển sang Advance và đã tạo {{to}}',
    roundUpdated: 'Đã cập nhật vòng',
    roundAdded: 'Đã thêm vòng',
    renamed_one: 'Đã đổi tên {{id}} thành "{{name}}" ({{count}} vòng)',
    renamed_other: 'Đã đổi tên {{id}} thành "{{name}}" ({{count}} vòng)',
    confirmDeleteRound: 'Xóa vòng {{id}}? Không thể hoàn tác.',
    roundDeleted: 'Đã xóa vòng',
    addPartnerFailed: 'Không thêm được đối tác',
    partnerAdded: 'Đã thêm đối tác "{{name}}" vào danh sách',
    addSalesRepFailed: 'Không thêm được Sales Rep',
    salesRepAdded: 'Đã thêm Sales Rep "{{name}}" vào danh sách',
    mailSent: ' — đã gửi yêu cầu duyệt đến {{to}}',
    mailFailed: ' — gửi email duyệt KHÔNG thành công ({{err}})',
    mailPending: ' — đang ở trạng thái Chờ duyệt. CHƯA gửi đến người duyệt: mở Duyệt dự án và bấm Gửi.',
    photosNotUploaded_one: ' — CẢNH BÁO {{count}} ảnh chưa được tải lên, hãy thêm vào từng SKU từ Sửa',
    photosNotUploaded_other: ' — CẢNH BÁO {{count}} ảnh chưa được tải lên, hãy thêm vào từng SKU từ Sửa',
    photosUploaded_one: ' — đã tải lên {{count}} ảnh',
    photosUploaded_other: ' — đã tải lên {{count}} ảnh',
    photosPartial: ' — CẢNH BÁO chỉ tải lên được {{done}}/{{wanted}} ảnh, hãy thêm phần còn lại trên SKU',
    movedInApproved_one: ' · đã chuyển vào {{count}} SKU đã duyệt — dự án ở trạng thái Đã duyệt',
    movedInApproved_other: ' · đã chuyển vào {{count}} SKU đã duyệt — dự án ở trạng thái Đã duyệt',
    notMovedRetry: ' — CHƯA chuyển được: {{list}}. Mở dự án bằng Sửa để thử lại.',
    newSkus_one: ' ({{count}} SKU mới)',
    newSkus_other: ' ({{count}} SKU mới)',
    createdPending: 'Đã tạo {{id}} ở trạng thái Chờ duyệt',
    created: 'Đã tạo {{id}}',
    newTicketN: 'ticket mới #{{n}}',
    removeSkuFailed: 'Không bỏ được SKU khỏi nhóm',
    skuRemovedFrom: 'Đã bỏ {{id}} khỏi {{group}}',
    ticketWord: 'ticket',
    ticketsEmailed: ' · đã gửi email {{n}} ticket',
    emailNotSent: ' · CHƯA GỬI EMAIL — {{list}}',
    createTicketFailed: 'Không tạo được ticket {{code}}',
    ticketsAddedTo_one: 'Đã thêm {{count}} ticket vào {{id}}',
    ticketsAddedTo_other: 'Đã thêm {{count}} ticket vào {{id}}',
    noNewTicket: 'Không có ticket mới để thêm',
    refusedBefore: 'Lần lưu này bị từ chối trước khi ghi bất cứ dữ liệu nào.',
    updateFailed: 'Không cập nhật được {{id}}',
    updateTicketFailed: 'Không cập nhật được ticket {{id}}',
    addSkuFailed: 'Không thêm được SKU',
    skuMovedIn: ' · đã chuyển vào {{n}} SKU',
    notMoved: ' — CHƯA chuyển được: {{list}}',
    groupUpdated: 'Đã cập nhật nhóm',
    skusUpdated: ' · đã cập nhật {{n}} SKU',
    ticketsUpdated: ' · đã cập nhật {{n}} ticket',
    skusAdded: ' · đã thêm {{n}} SKU',
    ticketsAdded: ' · đã thêm {{n}} ticket',
    previewFailed: 'Không tạo được bản xem trước',
    completeOpenFailed: 'Không mở được hộp thoại Hoàn thành: {{err}}',
    completeFailed: 'Không hoàn tất được dự án',
    completed: '{{id}} đã đánh dấu Hoàn thành — đã gửi email đến {{to}}',
    exportedProjects: 'Đã xuất Excel — {{groups}} dự án, {{skus}} SKU',
    exportedTickets: 'Đã xuất Excel — {{n}} ticket',
    exported: 'Đã xuất Excel',
    noRowsExport: 'Không có dòng nào để xuất',
    projectUpdated: 'Đã cập nhật dự án',
    projectAdded: 'Đã thêm dự án',
    createGroupFailed: 'Không tạo được nhóm',
    confirmDeleteProject: 'Xóa dự án {{id}}? Không thể hoàn tác.',
    projectDeleted: 'Đã xóa dự án',
    ticketSavedMailFailed: 'Đã lưu ticket nhưng gửi email không thành công: {{err}}',
    ticketSavedSent: 'Đã lưu ticket và gửi email',
    ticketSaved: 'Đã lưu ticket',
    ticketDeletedNotified: '{{id}} đã xóa — đã gửi thông báo hủy đến {{to}}',
    ticketDeletedMailFailed: '{{id}} đã xóa — CẢNH BÁO gửi email hủy không thành công, hãy báo trực tiếp cho họ',
    ticketDeletedNeverEmailed: '{{id}} đã xóa (ticket chưa từng được gửi email nên không ai được báo)',
    reminderSentTo: 'Đã gửi nhắc nhở đến {{to}}',
    emailSent: 'Đã gửi email',
    remindFailedPlain: 'Không gửi được nhắc nhở',
    reminderFor: 'Đã gửi nhắc nhở cho {{id}} đến {{to}}.',
    reminderFailed: 'Gửi nhắc nhở không thành công: {{err}}',
    sendTicketFailed: 'Không gửi được email ticket',
  },

  xls: {
    titleProjects: 'Helinox - Theo dõi dự án',
    titleTickets: 'Helinox - Ticket Station',
    titleSamples: 'Helinox - Tất cả mẫu',
    status: 'Trạng thái: {{v}}',
    team: 'Nhóm: {{v}}',
    owner: 'Chủ dự án: {{v}}',
    developer: 'Developer: {{v}}',
    designer: 'Designer: {{v}}',
    salesRep: 'Sales Rep: {{v}}',
    search: 'Tìm kiếm: {{v}}',
    card: 'Thẻ: {{v}}',
    requester: 'Người yêu cầu: {{v}}',
    sopTeam: 'Nhóm Sales OP: {{v}}',
    receivingTeam: 'Bộ phận nhận: {{v}}',
    priority: 'Ưu tiên: {{v}}',
    sample: 'Mẫu: {{v}}',
    round: 'Vòng: {{v}}',
    location: 'Địa điểm: {{v}}',
    allLocations: 'Tất cả địa điểm',
    sampleFinish: 'Hoàn thành mẫu',
    qty: 'SL',
  },
};

const zh = {
  launchPast: '{{month}} 已经过去。请选择本月或之后。',
  launchMismatch: '{{month}} 不在 {{season}} 的常见上市区间（{{from}} – {{to}}）内。年份正确吗？',
  launchConfirmBox: '是的，此目标上市月份无误',
  requestFailed: '请求失败（{{status}}）',
  loadFailed: '无法加载样品跟踪（{{status}}）',
  loadTicketsFailed: '无法加载工单（{{status}}）',
  saveFailed: '保存失败（{{status}}）',
  saveFailedPlain: '保存失败',
  deleteFailed: '删除失败（{{status}}）',
  deleteFailedPlain: '删除失败',
  cannotDelete: '无法删除（{{status}}）',
  renameFailed: '重命名失败（{{status}}）',
  sendFailed: '发送失败（{{status}}）',
  exportFailed: '导出失败（{{status}}）',
  exportFailedPlain: '导出失败',
  preparingExport: '正在准备导出 Excel...',
  saving: '保存中...',
  auto: '（自动）',
  noneSelected: '未选择',
  noOptions: '无选项',

  stageLateHint: '目标日期已过，此阶段仍未完成',
  costingFromQuote: '来自 Collab Pricing 报价 {{id}} — 点击打开',
  pickDate: '选择日期',
  targetDate: '目标日期',
  clearToPending: '清除（恢复为 Pending）',
  pickMonth: '选择月份',
  prevYear: '上一年',
  year: '年份',
  nextYear: '下一年',
  monShort: {
    m01: '1月', m02: '2月', m03: '3月', m04: '4月', m05: '5月', m06: '6月',
    m07: '7月', m08: '8月', m09: '9月', m10: '10月', m11: '11月', m12: '12月',
  },
  monLong: {
    m01: '1月', m02: '2月', m03: '3月', m04: '4月', m05: '5月', m06: '6月',
    m07: '7月', m08: '8月', m09: '9月', m10: '10月', m11: '11月', m12: '12月',
  },

  v: {
    projectName: '项目名称为必填项',
    required: '{{label}}为必填项',
    team: '团队为必填项',
    category: '类别为必填项',
    year: '年份为必填项',
    maxSeasons: '最多选择两个季',
    owner: '项目负责人（Sales OP）为必填项',
    salesRep: '销售代表为必填项',
    purpose: '项目目的为必填项',
    targetLaunch: '目标上市（月份）为必填项',
    launchPast: '目标上市月份早于本月——请选择本月或之后。',
    launchConfirm: '目标上市月份与年份和季节不符——如无误请勾选确认，否则请修改。',
    skuItemName: 'SKU {{n}}：品项 / SKU 名称为必填项（或用 x 移除该卡片）',
    skuMissing_one: 'SKU {{n}}：{{fields}}为必填项',
    skuMissing_other: 'SKU {{n}}：{{fields}}为必填项',
    namedMissing_one: '{{name}}：{{fields}}为必填项',
    namedMissing_other: '{{name}}：{{fields}}为必填项',
    pickSample: '请选择该轮次所属的样品——轮次总是添加到已有样品下',
    styleItem: '款式 / 品项为必填项',
    round: '轮次为必填项',
    rmReady: 'RM 就绪日期为必填项',
    devOrDesigner: '开发员或设计师至少须填写一位',
    reqDateInternal: 'HEVN 内部评审须填写申请日期',
    reviewDate: '结果为 {{outcome}} 时，评审日期（意见日期）为必填项',
    remarksDropped: '结果为 Dropped 时，备注为必填项',
    reworkReason: '结果为 Rework 时，至少须选择一个返工原因',
    newBasePhoto: '新的 Base ID 至少需要一张样品照片',
    groupName: '项目组名称为必填项。',
    projectId: '项目 ID 为必填项',
    ticketType: '工单类型为必填项',
    noOwner: '{{id}} 尚无项目负责人——请在项目跟踪中打开该项目（所在行的铅笔图标），设置项目负责人并保存，然后再创建工单。',
    groupEmailSend: '勾选“保存后发送邮件”时须填写群组邮箱',
    saveBeforeSend: '请先保存此工单，再手动发送邮件。',
    groupEmailBefore: '发送前须填写群组邮箱。',
    recipient: '须填写邮件收件人。',
  },
  skuReq: {
    estimateQty: '预计数量',
    exfShipDate: 'EXF 出货日期',
    targetPrice: '目标价',
    launchDate: '上市日期',
  },
  newSkuN: '新 SKU {{n}}',

  outcomeDesc: {
    advance: 'Advance - 当前样品已通过评审，批准进入下一开发轮次。须登记新的轮次。',
    rework: 'Rework - 样品被驳回，下次评审前须返工。',
    confirmed: 'Confirmed - 样品已批准，无需再进行开发轮次。',
    dropped: 'Dropped - 该款式的开发已终止，不再继续任何工作。',
    onHold: 'On Hold - 决策人尚未决定是否推进。在作出决定前，暂缓此轮结果。',
  },
  review: {
    done: '已完成',
    inReview: '评审中',
    waiting: '等待 2 周以上',
  },
  reviewChipDays: '{{label}} · 最近 {{n}} 天',
  flag: {
    costingPending: '成本核算待处理',
    productionPending: '生产待处理',
    shipmentPending: '出货待处理',
    pastDue: '已逾期',
    noSample: '尚无样品',
  },
  lateChip: '逾期超过 {{n}} 天',
  caseA: '情形 A - HPAC 直接合作',
  caseB: '情形 B - 子公司主导的合作',

  stillNeeded: '发送此工单前还需填写：{{list}}',
  subjectPh: '[项目名称] - [工单代码] - [工单名称]',

  searchPartner: '搜索合作方 / 产品线…',
  noMatch: '没有与“{{q}}”匹配的结果',
  adding: '添加中…',
  addTo: '+ 将“{{name}}”添加到{{list}}',
  theList: '列表',
  salesRepList: '销售代表列表',

  fillSeasonPartner: '— 请填写季和合作方 / 产品线 —',
  fillSeason: '— 请填写季 —',
  nameManager: '{{name}}（经理）',
  salesRepLabel: '销售代表',
  searchSalesRep: '搜索或添加销售代表…',
  keywordPh: '例如：Chair One',
  notePh: '审批人需要了解的信息——将包含在审批申请邮件中',
  noSkuYet: '尚无 SKU——没关系。项目可以先空着创建，之后再添加 SKU。',

  ofTotal: '{{label}} - 共 {{total}} 个',
  projectFallback: '项目',
  unassigned: '— 未分配 —',

  editRound: '编辑轮次',
  notMine: '此轮次负责人为 {{name}} — 设计师和开发人员只能修改自己的轮次。请先请团队经理改为你的名字。',
  duplicateRound: '复制轮次',
  deleteRound: '删除轮次',
  addRound: '添加轮次',
  editBase: '编辑 Base ID（照片、款式名称）',
  noRounds: '没有可显示的轮次',
  noData: '没有可显示的数据',
  searchSample: '搜索样品...',
  showColumns: '显示列',
  showAll: '全部显示',
  prjItems_one: '{{count}} 个 PRJ 条目',
  prjItems_other: '{{count}} 个 PRJ 条目',
  editSkusOfProject: '编辑此项目的 SKU',
  editGroup: '编辑项目组',
  ticketsForProject: '此项目的工单',
  deleteProjectAdmin: '删除此项目及其全部 SKU（管理员）',
  createSampleFor: '为此项目创建样品',
  plusSample: '+ 样品',
  markComplete: '标记为完成并通知生产',
  complete: '完成',
  editSku: '编辑此 SKU',
  deleteProject: '删除项目',
  noReplyEmailed: '尚无回复——已向接收团队发送邮件，但对方尚未答复。',
  noReplyNeverEmailed: '尚无回复——此工单从未发送过邮件，因此没有人被询问。',

  completeTitle: '完成 {{id}}——通知生产',
  preparingEmail: '正在准备邮件…',
  to: '收件人',
  subject: '主题',
  message: '正文',
  completeNote: '只有在此邮件发出后，状态才会变为 <b>Complete</b>。点击取消则不会有任何变更。',
  sending: '发送中…',
  sendMarkComplete: '发送并标记为完成',

  dupTitle: '可能重复',
  dupLead: '已存在相同 <b>季 + 合作方 / 产品线</b> 的项目：',
  dupHint: '同一合作方和季同时进行多个项目的情况确实存在——这只是警告，不会阻止。',
  createAnyway: '仍然创建',

  msg: {
    deletingProject: '正在删除项目...',
    groupDeleted: '{{id}} 已删除——移除了 {{skus}} 个 SKU，{{rounds}} 个样品轮次保留但不再关联项目',
    ticketsCancelled: ' · 已取消 {{n}} 个工单',
    ticketsCancelledNotified: ' · 已取消 {{n}} 个工单，已通知 {{m}} 个邮箱',
    advanceCancelled: '已取消 - {{id}} 未设为 Advance，也未创建新轮次',
    theRound: '该轮次',
    photosAttached_one: ' — 已将 {{count}} 张照片附加到 {{base}}',
    photosAttached_other: ' — 已将 {{count}} 张照片附加到 {{base}}',
    theBaseId: '该 Base ID',
    advanceSaved: '{{from}} 已设为 Advance，并已创建 {{to}}',
    roundUpdated: '轮次已更新',
    roundAdded: '轮次已添加',
    renamed_one: '{{id}} 已重命名为“{{name}}”（{{count}} 个轮次）',
    renamed_other: '{{id}} 已重命名为“{{name}}”（{{count}} 个轮次）',
    confirmDeleteRound: '删除轮次 {{id}}？此操作无法撤销。',
    roundDeleted: '轮次已删除',
    addPartnerFailed: '添加合作方失败',
    partnerAdded: '合作方“{{name}}”已添加到列表',
    addSalesRepFailed: '添加销售代表失败',
    salesRepAdded: '销售代表“{{name}}”已添加到列表',
    mailSent: ' — 审批申请已发送至 {{to}}',
    mailFailed: ' — 审批邮件发送失败（{{err}}）',
    mailPending: ' — 当前为待审批状态，尚未发送给审批人：请打开项目审批并点击提交。',
    photosNotUploaded_one: ' — 警告：{{count}} 张照片未上传，请在编辑中为各 SKU 添加',
    photosNotUploaded_other: ' — 警告：{{count}} 张照片未上传，请在编辑中为各 SKU 添加',
    photosUploaded_one: ' — 已上传 {{count}} 张照片',
    photosUploaded_other: ' — 已上传 {{count}} 张照片',
    photosPartial: ' — 警告：{{wanted}} 张照片中仅上传了 {{done}} 张，请在 SKU 上补充其余照片',
    movedInApproved_one: ' · 已移入 {{count}} 个已批准的 SKU——项目已为已批准状态',
    movedInApproved_other: ' · 已移入 {{count}} 个已批准的 SKU——项目已为已批准状态',
    notMovedRetry: ' — 未移入：{{list}}。请用编辑打开项目后重试。',
    newSkus_one: '（{{count}} 个新 SKU）',
    newSkus_other: '（{{count}} 个新 SKU）',
    createdPending: '已创建 {{id}}，状态为待审批',
    created: '已创建 {{id}}',
    newTicketN: '新工单 #{{n}}',
    removeSkuFailed: '无法从项目组中移除 SKU',
    skuRemovedFrom: '已将 {{id}} 从 {{group}} 移除',
    ticketWord: '工单',
    ticketsEmailed: ' · 已发送 {{n}} 个工单邮件',
    emailNotSent: ' · 邮件未发送——{{list}}',
    createTicketFailed: '创建工单 {{code}} 失败',
    ticketsAddedTo_one: '已向 {{id}} 添加 {{count}} 个工单',
    ticketsAddedTo_other: '已向 {{id}} 添加 {{count}} 个工单',
    noNewTicket: '没有要添加的新工单',
    refusedBefore: '本次保存在写入任何内容之前已被拒绝。',
    updateFailed: '更新 {{id}} 失败',
    updateTicketFailed: '更新工单 {{id}} 失败',
    addSkuFailed: '添加 SKU 失败',
    skuMovedIn: ' · 已移入 {{n}} 个 SKU',
    notMoved: ' — 未移入：{{list}}',
    groupUpdated: '项目组已更新',
    skusUpdated: ' · 已更新 {{n}} 个 SKU',
    ticketsUpdated: ' · 已更新 {{n}} 个工单',
    skusAdded: ' · 已添加 {{n}} 个 SKU',
    ticketsAdded: ' · 已添加 {{n}} 个工单',
    previewFailed: '无法生成预览',
    completeOpenFailed: '无法打开完成对话框：{{err}}',
    completeFailed: '无法完成该项目',
    completed: '{{id}} 已标记为完成——邮件已发送至 {{to}}',
    exportedProjects: '已导出 Excel——{{groups}} 个项目，{{skus}} 个 SKU',
    exportedTickets: '已导出 Excel——{{n}} 个工单',
    exported: '已导出 Excel',
    noRowsExport: '没有可导出的行',
    projectUpdated: '项目已更新',
    projectAdded: '项目已添加',
    createGroupFailed: '创建项目组失败',
    confirmDeleteProject: '删除项目 {{id}}？此操作无法撤销。',
    projectDeleted: '项目已删除',
    ticketSavedMailFailed: '工单已保存，但邮件发送失败：{{err}}',
    ticketSavedSent: '工单已保存并已发送邮件',
    ticketSaved: '工单已保存',
    ticketDeletedNotified: '{{id}} 已删除——取消通知已发送至 {{to}}',
    ticketDeletedMailFailed: '{{id}} 已删除——警告：取消邮件发送失败，请手动告知对方',
    ticketDeletedNeverEmailed: '{{id}} 已删除（该工单从未发送过邮件，因此未通知任何人）',
    reminderSentTo: '提醒已发送至 {{to}}',
    emailSent: '邮件已发送',
    remindFailedPlain: '无法发送提醒',
    reminderFor: '{{id}} 的提醒已发送至 {{to}}。',
    reminderFailed: '提醒发送失败：{{err}}',
    sendTicketFailed: '无法发送工单邮件',
  },

  xls: {
    titleProjects: 'Helinox - 项目跟踪',
    titleTickets: 'Helinox - 工单中心',
    titleSamples: 'Helinox - 全部样品',
    status: '状态：{{v}}',
    team: '团队：{{v}}',
    owner: '项目负责人：{{v}}',
    developer: '开发员：{{v}}',
    designer: '设计师：{{v}}',
    salesRep: '销售代表：{{v}}',
    search: '搜索：{{v}}',
    card: '卡片：{{v}}',
    requester: '申请人：{{v}}',
    sopTeam: 'Sales OP 团队：{{v}}',
    receivingTeam: '接收团队：{{v}}',
    priority: '优先级：{{v}}',
    sample: '样品：{{v}}',
    round: '轮次：{{v}}',
    location: '地点：{{v}}',
    allLocations: '全部地点',
    sampleFinish: '样品完成',
    qty: '数量',
  },
};

// French and Japanese (task #1173, 2026-11-04) — generated from `en`; a string not yet translated reads English.
const fr = {
  "launchPast": "{{month}} est déjà passé. Choisissez ce mois ou un mois ultérieur.",
  "launchMismatch": "{{month}} est en dehors de la fenêtre de lancement habituelle de {{season}} ({{from}} – {{to}}). L'année est-elle correcte ?",
  "launchConfirmBox": "Oui, ce Lancement cible est correct",
  "requestFailed": "Échec de la requête ({{status}})",
  "loadFailed": "Échec du chargement de Sample Tracker ({{status}})",
  "loadTicketsFailed": "Échec du chargement des tickets ({{status}})",
  "saveFailed": "Échec de l'enregistrement ({{status}})",
  "saveFailedPlain": "Échec de l'enregistrement",
  "deleteFailed": "Échec de la suppression ({{status}})",
  "deleteFailedPlain": "Échec de la suppression",
  "cannotDelete": "Suppression impossible ({{status}})",
  "renameFailed": "Échec du renommage ({{status}})",
  "sendFailed": "Échec de l'envoi ({{status}})",
  "exportFailed": "Échec de l'export ({{status}})",
  "exportFailedPlain": "Échec de l'export",
  "preparingExport": "Préparation de l'export Excel...",
  "saving": "Enregistrement...",
  "auto": "(auto)",
  "noneSelected": "Aucune sélection",
  "noOptions": "Aucune option",
  "stageLateHint": "La date cible est dépassée et cette étape est toujours ouverte",
  "costingFromQuote": "Depuis le devis Collab Pricing {{id}} — l'ouvrir",
  "pickDate": "Choisir une date",
  "targetDate": "Date cible",
  "clearToPending": "Effacer (retour à Pending)",
  "pickMonth": "Choisir un mois",
  "prevYear": "Année précédente",
  "year": "Année",
  "nextYear": "Année suivante",
  "monShort": {
    "m01": "janv.",
    "m02": "févr.",
    "m03": "mars",
    "m04": "avr.",
    "m05": "mai",
    "m06": "juin",
    "m07": "juil.",
    "m08": "août",
    "m09": "sept.",
    "m10": "oct.",
    "m11": "nov.",
    "m12": "déc."
  },
  "monLong": {
    "m01": "janvier",
    "m02": "février",
    "m03": "mars",
    "m04": "avril",
    "m05": "mai",
    "m06": "juin",
    "m07": "juillet",
    "m08": "août",
    "m09": "septembre",
    "m10": "octobre",
    "m11": "novembre",
    "m12": "décembre"
  },
  "v": {
    "projectName": "Le nom du projet est obligatoire",
    "required": "{{label}} est obligatoire",
    "team": "L'équipe est obligatoire",
    "category": "La catégorie est obligatoire",
    "year": "L'année est obligatoire",
    "maxSeasons": "Choisissez deux saisons au maximum",
    "owner": "Le responsable du projet (Sales OP) est obligatoire",
    "salesRep": "Le Sales Rep est obligatoire",
    "purpose": "L'objectif du projet est obligatoire",
    "targetLaunch": "Le lancement cible (mois) est obligatoire",
    "launchPast": "Le lancement cible est antérieur à ce mois — choisissez ce mois ou un mois ultérieur.",
    "launchConfirm": "Le lancement cible ne correspond pas à l'année et à la saison — cochez pour confirmer qu'il est correct, ou corrigez-le.",
    "skuItemName": "SKU {{n}} : Item / SKU Name est obligatoire (ou supprimez la carte avec x)",
    "skuMissing_one": "SKU {{n}} : {{fields}} est obligatoire",
    "skuMissing_other": "SKU {{n}} : {{fields}} sont obligatoires",
    "namedMissing_one": "{{name}} : {{fields}} est obligatoire",
    "namedMissing_other": "{{name}} : {{fields}} sont obligatoires",
    "pickSample": "Choisissez l'échantillon auquel ce tour appartient — un tour est toujours ajouté à un échantillon existant",
    "styleItem": "Style / Item est obligatoire",
    "round": "Le tour est obligatoire",
    "rmReady": "RM Ready Date est obligatoire",
    "devOrDesigner": "Un développeur ou un designer est obligatoire",
    "reqDateInternal": "La date de demande est obligatoire pour la revue interne HEVN",
    "reviewDate": "La date de revue (date du commentaire) est obligatoire lorsque le résultat est {{outcome}}",
    "remarksDropped": "Les remarques sont obligatoires lorsque le résultat est Dropped",
    "reworkReason": "Au moins un motif de reprise est obligatoire lorsque le résultat est Rework",
    "newBasePhoto": "Un nouveau Base ID nécessite au moins une photo de l'échantillon",
    "groupName": "Le nom du groupe est obligatoire.",
    "projectId": "L'ID du projet est obligatoire",
    "ticketType": "Le type de ticket est obligatoire",
    "noOwner": "{{id}} n'a pas encore de responsable de projet — ouvrez le projet dans Project Tracker (le crayon sur sa ligne), définissez le responsable de projet et enregistrez, puis créez le ticket.",
    "groupEmailSend": "L'e-mail du groupe est obligatoire lorsque « Envoyer un e-mail après l'enregistrement » est coché",
    "saveBeforeSend": "Veuillez enregistrer ce ticket avant d'envoyer l'e-mail manuellement.",
    "groupEmailBefore": "L'e-mail du groupe est obligatoire avant l'envoi.",
    "recipient": "Un destinataire de l'e-mail est obligatoire."
  },
  "skuReq": {
    "estimateQty": "Quantité estimée",
    "exfShipDate": "Date d'expédition EXF",
    "targetPrice": "Prix cible",
    "launchDate": "Date de lancement"
  },
  "newSkuN": "Nouveau SKU {{n}}",
  "outcomeDesc": {
    "advance": "Advance - L'échantillon actuel a été examiné et approuvé pour passer au tour de développement suivant. Un nouveau tour doit être enregistré.",
    "rework": "Rework - L'échantillon a été rejeté et doit être repris avant la prochaine revue.",
    "confirmed": "Confirmed - L'échantillon a été approuvé et aucun tour de développement supplémentaire n'est nécessaire.",
    "dropped": "Dropped - Le développement de ce style a été arrêté et aucun autre travail ne sera effectué.",
    "onHold": "On Hold - Le décideur n'a pas encore tranché entre go et no-go. Mettez le résultat de ce tour en attente jusqu'à la décision."
  },
  "review": {
    "done": "Terminé",
    "inReview": "En revue",
    "waiting": "En attente depuis 2 semaines+"
  },
  "reviewChipDays": "{{label}} · {{n}} derniers jours",
  "flag": {
    "costingPending": "Coût en attente",
    "productionPending": "Production en attente",
    "shipmentPending": "Expédition en attente",
    "pastDue": "Échéance dépassée",
    "noSample": "Pas encore d'échantillon"
  },
  "lateChip": "Plus de {{n}} jours de retard",
  "caseA": "Cas A - Collaboration directe HPAC",
  "caseB": "Cas B - Collaboration pilotée par une filiale",
  "stillNeeded": "Encore nécessaire avant l'envoi de ce ticket : {{list}}",
  "subjectPh": "[Project Name] - [Ticket Code] - [Ticket Name]",
  "searchPartner": "Rechercher un partenaire / une ligne…",
  "noMatch": "Aucun résultat pour « {{q}} »",
  "adding": "Ajout en cours…",
  "addTo": "+ Ajouter « {{name}} » à {{list}}",
  "theList": "la liste",
  "salesRepList": "la liste des Sales Rep",
  "fillSeasonPartner": "— renseignez la saison et le partenaire / la ligne —",
  "fillSeason": "— renseignez la saison —",
  "nameManager": "{{name}} (responsable)",
  "salesRepLabel": "Commercial",
  "searchSalesRep": "Rechercher ou ajouter un Sales Rep…",
  "keywordPh": "p. ex. Chair One",
  "notePh": "Tout ce que l'approbateur doit savoir — inclus dans l'e-mail de demande d'approbation",
  "noSkuYet": "Pas encore de SKU — ce n'est pas un problème. Un projet peut être créé vide et les SKU ajoutés plus tard.",
  "ofTotal": "{{label}} - sur {{total}} au total",
  "projectFallback": "Projet",
  "unassigned": "— non assigné —",
  "editRound": "Modifier le tour",
  "notMine": "Au nom de {{name}} — les designers et développeurs ne modifient que leurs propres tours. Demandez à votre responsable d'équipe de vous le réassigner.",
  "duplicateRound": "Dupliquer le tour",
  "deleteRound": "Supprimer le tour",
  "addRound": "Ajouter un tour",
  "editBase": "Modifier le Base ID (photos, nom du style)",
  "noRounds": "Aucun tour à afficher",
  "noData": "Aucune donnée à afficher",
  "searchSample": "Rechercher un échantillon...",
  "showColumns": "Afficher les colonnes",
  "showAll": "Tout afficher",
  "prjItems_one": "{{count}} élément PRJ",
  "prjItems_other": "{{count}} éléments PRJ",
  "editSkusOfProject": "Modifier les SKU de ce projet",
  "editGroup": "Modifier le groupe de projets",
  "ticketsForProject": "Tickets de ce projet",
  "deleteProjectAdmin": "Supprimer ce projet et tous ses SKU (admin)",
  "createSampleFor": "Créer un échantillon pour ce projet",
  "plusSample": "+ Échantillon",
  "markComplete": "Marquer comme terminé et notifier la Production",
  "complete": "Terminer",
  "editSku": "Modifier ce SKU",
  "deleteProject": "Supprimer le projet",
  "noReplyEmailed": "Pas encore de réponse — l'équipe destinataire a reçu un e-mail et n'a pas répondu.",
  "noReplyNeverEmailed": "Pas encore de réponse — ce ticket n'a jamais été envoyé par e-mail, personne n'a donc été sollicité.",
  "completeTitle": "Terminer {{id}} — notifier la Production",
  "preparingEmail": "Préparation de l'e-mail…",
  "to": "À",
  "subject": "Objet",
  "message": "Message",
  "completeNote": "Le statut ne passe à <b>Complete</b> que lorsque cet e-mail est envoyé. Si vous annulez, rien ne change.",
  "sending": "Envoi en cours…",
  "sendMarkComplete": "Envoyer et marquer Complete",
  "dupTitle": "Doublon possible",
  "dupLead": "Un projet avec cette <b>saison + ce partenaire / cette ligne</b> existe déjà :",
  "dupHint": "Il arrive d'avoir des projets parallèles pour le même partenaire et la même saison — il s'agit d'un avertissement, pas d'un blocage.",
  "createAnyway": "Le créer quand même",
  "msg": {
    "deletingProject": "Suppression du projet...",
    "groupDeleted": "{{id}} supprimé — {{skus}} SKU supprimé(s), {{rounds}} tour(s) d'échantillon conservé(s) sans projet",
    "ticketsCancelled": " · {{n}} ticket(s) annulé(s)",
    "ticketsCancelledNotified": " · {{n}} ticket(s) annulé(s), {{m}} boîte(s) aux lettres notifiée(s)",
    "advanceCancelled": "Annulé - {{id}} n'a PAS été défini sur Advance et aucun nouveau tour n'a été créé",
    "theRound": "le tour",
    "photosAttached_one": " — {{count}} photo jointe à {{base}}",
    "photosAttached_other": " — {{count}} photos jointes à {{base}}",
    "theBaseId": "le Base ID",
    "advanceSaved": "{{from}} défini sur Advance et {{to}} créé",
    "roundUpdated": "Tour mis à jour",
    "roundAdded": "Tour ajouté",
    "renamed_one": "{{id}} renommé en \"{{name}}\" ({{count}} tour)",
    "renamed_other": "{{id}} renommé en \"{{name}}\" ({{count}} tours)",
    "confirmDeleteRound": "Supprimer le tour {{id}} ? Cette action est irréversible.",
    "roundDeleted": "Tour supprimé",
    "addPartnerFailed": "Échec de l'ajout du partenaire",
    "partnerAdded": "Partenaire \"{{name}}\" ajouté à la liste",
    "addSalesRepFailed": "Échec de l'ajout du Sales Rep",
    "salesRepAdded": "Sales Rep \"{{name}}\" ajouté à la liste",
    "mailSent": " — demande d'approbation envoyée à {{to}}",
    "mailFailed": " — ÉCHEC de l'e-mail d'approbation ({{err}})",
    "mailPending": " — maintenant en Pending Approval. Il n'est PAS encore envoyé à l'approbateur : ouvrez Project Approval et cliquez sur Soumettre.",
    "photosNotUploaded_one": " — ATTENTION {{count}} photo non importée, ajoutez-la sur chaque SKU depuis Modifier",
    "photosNotUploaded_other": " — ATTENTION {{count}} photos non importées, ajoutez-les sur chaque SKU depuis Modifier",
    "photosUploaded_one": " — {{count}} photo importée",
    "photosUploaded_other": " — {{count}} photos importées",
    "photosPartial": " — ATTENTION seulement {{done}} photos sur {{wanted}} importées, ajoutez les autres sur le SKU",
    "movedInApproved_one": " · {{count}} SKU approuvé déplacé dedans — le projet est Approved",
    "movedInApproved_other": " · {{count}} SKU approuvés déplacés dedans — le projet est Approved",
    "notMovedRetry": " — NON déplacés : {{list}}. Ouvrez le projet avec Modifier pour réessayer.",
    "newSkus_one": " ({{count}} nouveau SKU)",
    "newSkus_other": " ({{count}} nouveaux SKU)",
    "createdPending": "{{id}} créé en Pending Approval",
    "created": "{{id}} créé",
    "newTicketN": "le nouveau ticket n° {{n}}",
    "removeSkuFailed": "Échec du retrait du SKU du groupe",
    "skuRemovedFrom": "{{id}} retiré de {{group}}",
    "ticketWord": "ticket",
    "ticketsEmailed": " · {{n}} ticket envoyé par e-mail",
    "emailNotSent": " · E-MAIL NON ENVOYÉ — {{list}}",
    "createTicketFailed": "Échec de la création du ticket {{code}}",
    "ticketsAddedTo_one": "{{count}} ticket ajouté à {{id}}",
    "ticketsAddedTo_other": "{{count}} tickets ajoutés à {{id}}",
    "noNewTicket": "Aucun nouveau ticket à ajouter",
    "refusedBefore": "Cet enregistrement a été refusé avant que quoi que ce soit ne soit écrit.",
    "updateFailed": "Échec de la mise à jour de {{id}}",
    "updateTicketFailed": "Échec de la mise à jour du ticket {{id}}",
    "addSkuFailed": "Échec de l'ajout du SKU",
    "skuMovedIn": " · {{n}} SKU déplacé dedans",
    "notMoved": " — NON déplacés : {{list}}",
    "groupUpdated": "Groupe mis à jour",
    "skusUpdated": " · {{n}} SKU mis à jour",
    "ticketsUpdated": " · {{n}} ticket mis à jour",
    "skusAdded": " · {{n}} SKU ajouté",
    "ticketsAdded": " · {{n}} ticket ajouté",
    "previewFailed": "Impossible de générer l'aperçu",
    "completeOpenFailed": "Impossible d'ouvrir la boîte de dialogue Terminer : {{err}}",
    "completeFailed": "Impossible de terminer le projet",
    "completed": "{{id}} marqué Complete — e-mail envoyé à {{to}}",
    "exportedProjects": "Excel exporté — {{groups}} projets, {{skus}} SKU",
    "exportedTickets": "Excel exporté — {{n}} tickets",
    "exported": "Excel exporté",
    "noRowsExport": "Aucune ligne à exporter",
    "projectUpdated": "Projet mis à jour",
    "projectAdded": "Projet ajouté",
    "createGroupFailed": "Échec de la création du groupe",
    "confirmDeleteProject": "Supprimer le projet {{id}} ? Cette action est irréversible.",
    "projectDeleted": "Projet supprimé",
    "ticketSavedMailFailed": "Ticket enregistré, mais l'e-mail a échoué : {{err}}",
    "ticketSavedSent": "Ticket enregistré et e-mail envoyé",
    "ticketSaved": "Ticket enregistré",
    "ticketDeletedNotified": "{{id}} supprimé — avis d'annulation envoyé à {{to}}",
    "ticketDeletedMailFailed": "{{id}} supprimé — ATTENTION l'e-mail d'annulation a échoué, prévenez-les manuellement",
    "ticketDeletedNeverEmailed": "{{id}} supprimé (il n'avait jamais été envoyé par e-mail, personne n'a donc été notifié)",
    "reminderSentTo": "Rappel envoyé à {{to}}",
    "emailSent": "E-mail envoyé",
    "remindFailedPlain": "Impossible d'envoyer le rappel",
    "reminderFor": "Rappel pour {{id}} envoyé à {{to}}.",
    "reminderFailed": "Échec du rappel : {{err}}",
    "sendTicketFailed": "Impossible d'envoyer l'e-mail du ticket"
  },
  "xls": {
    "titleProjects": "Helinox - Suivi des projets",
    "titleTickets": "Helinox - Ticket Station",
    "titleSamples": "Helinox - Tous les échantillons",
    "status": "Statut : {{v}}",
    "team": "Équipe : {{v}}",
    "owner": "Responsable : {{v}}",
    "developer": "Développeur : {{v}}",
    "designer": "Designer : {{v}}",
    "salesRep": "Sales Rep : {{v}}",
    "search": "Recherche : {{v}}",
    "card": "Carte : {{v}}",
    "requester": "Demandeur : {{v}}",
    "sopTeam": "Équipe Sales OP : {{v}}",
    "receivingTeam": "Équipe destinataire : {{v}}",
    "priority": "Priorité : {{v}}",
    "sample": "Échantillon : {{v}}",
    "round": "Tour : {{v}}",
    "location": "Lieu : {{v}}",
    "allLocations": "Tous les lieux",
    "sampleFinish": "Finition de l'échantillon",
    "qty": "Qté"
  }
};
const ja = {
  "launchPast": "{{month}}はすでに過ぎています。今月以降を選択してください。",
  "launchMismatch": "{{month}}は、{{season}}の通常の発売時期（{{from}}～{{to}}）の範囲外です。年は正しいですか？",
  "launchConfirmBox": "はい、この目標発売時期で正しいです",
  "requestFailed": "リクエストに失敗しました（{{status}}）",
  "loadFailed": "Sample Trackerの読み込みに失敗しました（{{status}}）",
  "loadTicketsFailed": "チケットの読み込みに失敗しました（{{status}}）",
  "saveFailed": "保存に失敗しました（{{status}}）",
  "saveFailedPlain": "保存に失敗しました",
  "deleteFailed": "削除に失敗しました（{{status}}）",
  "deleteFailedPlain": "削除に失敗しました",
  "cannotDelete": "削除できません（{{status}}）",
  "renameFailed": "名前の変更に失敗しました（{{status}}）",
  "sendFailed": "送信に失敗しました（{{status}}）",
  "exportFailed": "エクスポートに失敗しました（{{status}}）",
  "exportFailedPlain": "エクスポートに失敗しました",
  "preparingExport": "Excelエクスポートを準備しています...",
  "saving": "保存中...",
  "auto": "（自動）",
  "noneSelected": "選択なし",
  "noOptions": "選択肢なし",
  "stageLateHint": "目標日を過ぎており、このステージはまだ未完了です",
  "costingFromQuote": "Collab Pricingの見積{{id}}から：開く",
  "pickDate": "日付を選択",
  "targetDate": "目標日",
  "clearToPending": "クリア（Pendingに戻す）",
  "pickMonth": "月を選択",
  "prevYear": "前の年",
  "year": "年",
  "nextYear": "次の年",
  "monShort": {
    "m01": "1月",
    "m02": "2月",
    "m03": "3月",
    "m04": "4月",
    "m05": "5月",
    "m06": "6月",
    "m07": "7月",
    "m08": "8月",
    "m09": "9月",
    "m10": "10月",
    "m11": "11月",
    "m12": "12月"
  },
  "monLong": {
    "m01": "1月",
    "m02": "2月",
    "m03": "3月",
    "m04": "4月",
    "m05": "5月",
    "m06": "6月",
    "m07": "7月",
    "m08": "8月",
    "m09": "9月",
    "m10": "10月",
    "m11": "11月",
    "m12": "12月"
  },
  "v": {
    "projectName": "プロジェクト名は必須です",
    "required": "{{label}}は必須です",
    "team": "チームは必須です",
    "category": "カテゴリーは必須です",
    "year": "年は必須です",
    "maxSeasons": "シーズンは最大2つまで選択してください",
    "owner": "プロジェクトオーナー（Sales OP）は必須です",
    "salesRep": "Sales Repは必須です",
    "purpose": "プロジェクトの目的は必須です",
    "targetLaunch": "ターゲットローンチ（月）は必須です",
    "launchPast": "ターゲットローンチが今月より前になっています。今月以降を選択してください。",
    "launchConfirm": "ターゲットローンチが年とシーズンに合っていません。正しい場合はチェックを入れるか、修正してください。",
    "skuItemName": "SKU {{n}}：Item / SKU Name は必須です（またはxでカードを削除してください）",
    "skuMissing_one": "SKU {{n}}：{{fields}}は必須です",
    "skuMissing_other": "SKU {{n}}：{{fields}}は必須です",
    "namedMissing_one": "{{name}}：{{fields}}は必須です",
    "namedMissing_other": "{{name}}：{{fields}}は必須です",
    "pickSample": "このラウンドが属するサンプルを選択してください。ラウンドは必ず既存のサンプルに追加されます",
    "styleItem": "Style / Item は必須です",
    "round": "ラウンドは必須です",
    "rmReady": "RM Ready Date は必須です",
    "devOrDesigner": "デベロッパーまたはデザイナーのいずれかが必須です",
    "reqDateInternal": "HEVN 社内レビューには依頼日が必須です",
    "reviewDate": "結果が{{outcome}}の場合、レビュー日（コメント日）は必須です",
    "remarksDropped": "結果が Dropped の場合、備考は必須です",
    "reworkReason": "結果が Rework の場合、Rework の理由を1つ以上選択してください",
    "newBasePhoto": "新しい Base ID にはサンプルの写真が1枚以上必要です",
    "groupName": "グループ名は必須です。",
    "projectId": "プロジェクトIDは必須です",
    "ticketType": "チケットタイプは必須です",
    "noOwner": "{{id}} にはまだプロジェクトオーナーがいません。Project Tracker でプロジェクトを開き（行のペンのアイコン）、プロジェクトオーナーを設定して保存してから、チケットを作成してください。",
    "groupEmailSend": "「保存後にメールを送信」にチェックが入っている場合、グループメールは必須です",
    "saveBeforeSend": "手動でメールを送信する前に、このチケットを保存してください。",
    "groupEmailBefore": "送信前にグループメールを入力してください。",
    "recipient": "メールの宛先は必須です。"
  },
  "skuReq": {
    "estimateQty": "見込数量",
    "exfShipDate": "EXF 出荷日",
    "targetPrice": "目標価格",
    "launchDate": "ローンチ日"
  },
  "newSkuN": "新規 SKU {{n}}",
  "outcomeDesc": {
    "advance": "Advance - 現在のサンプルのレビューが完了し、次の開発ラウンドへの進行が承認されました。新しいラウンドを登録する必要があります。",
    "rework": "Rework - サンプルは却下されました。次のレビューの前にやり直しが必要です。",
    "confirmed": "Confirmed - サンプルは承認されました。これ以上の開発ラウンドは不要です。",
    "dropped": "Dropped - このスタイルの開発は中止され、今後の作業は行われません。",
    "onHold": "On Hold - 意思決定者がまだ実施・見送りを決めていません。決定されるまで、このラウンドの結果は保留にしてください。"
  },
  "review": {
    "done": "完了",
    "inReview": "レビュー中",
    "waiting": "2週間以上待機"
  },
  "reviewChipDays": "{{label}} · 直近{{n}}日",
  "flag": {
    "costingPending": "コスティング待ち",
    "productionPending": "生産待ち",
    "shipmentPending": "出荷待ち",
    "pastDue": "期日超過",
    "noSample": "サンプルなし"
  },
  "lateChip": "{{n}}日以上の遅延",
  "caseA": "ケース A - HPAC 直接コラボレーション",
  "caseB": "ケース B - 子会社主導のコラボレーション",
  "stillNeeded": "このチケットを送信するには、次の項目がまだ必要です：{{list}}",
  "subjectPh": "[Project Name] - [Ticket Code] - [Ticket Name]",
  "searchPartner": "パートナー / ラインを検索…",
  "noMatch": "「{{q}}」に該当するものはありません",
  "adding": "追加中…",
  "addTo": "+ 「{{name}}」を{{list}}に追加",
  "theList": "リスト",
  "salesRepList": "Sales Rep リスト",
  "fillSeasonPartner": "— シーズンとパートナー / ラインを入力してください —",
  "fillSeason": "— シーズンを入力してください —",
  "nameManager": "{{name}}（マネージャー）",
  "salesRepLabel": "営業担当",
  "searchSalesRep": "Sales Rep を検索または追加…",
  "keywordPh": "例：Chair One",
  "notePh": "承認者に伝えておきたいこと — 承認依頼メールに含まれます",
  "noSkuYet": "SKU はまだありません。問題ありません。プロジェクトは空で作成し、SKU を後から追加できます。",
  "ofTotal": "{{label}} - 全{{total}}件中",
  "projectFallback": "プロジェクト",
  "unassigned": "— 未割り当て —",
  "editRound": "ラウンドを編集",
  "notMine": "{{name}}さん名義です。デザイナーとデベロッパーは自分のラウンドのみ変更できます。チームマネージャーに自分への再割り当てを依頼してください。",
  "duplicateRound": "ラウンドを複製",
  "deleteRound": "ラウンドを削除",
  "addRound": "ラウンドを追加",
  "editBase": "Base ID を編集（写真、スタイル名）",
  "noRounds": "表示するラウンドがありません",
  "noData": "表示するデータがありません",
  "searchSample": "サンプルを検索...",
  "showColumns": "列を表示",
  "showAll": "すべて表示",
  "prjItems_one": "PRJ {{count}}件",
  "prjItems_other": "PRJ {{count}}件",
  "editSkusOfProject": "このプロジェクトの SKU を編集",
  "editGroup": "プロジェクトグループを編集",
  "ticketsForProject": "このプロジェクトのチケット",
  "deleteProjectAdmin": "このプロジェクトとすべての SKU を削除（管理者）",
  "createSampleFor": "このプロジェクトのサンプルを作成",
  "plusSample": "+ サンプル",
  "markComplete": "完了にして生産部門に通知",
  "complete": "完了",
  "editSku": "この SKU を編集",
  "deleteProject": "プロジェクトを削除",
  "noReplyEmailed": "まだ返信がありません。受信チームにメールを送信済みですが、回答はありません。",
  "noReplyNeverEmailed": "まだ返信がありません。このチケットはメール送信されたことがないため、誰にも依頼されていません。",
  "completeTitle": "{{id}} を完了 — 生産部門に通知",
  "preparingEmail": "メールを準備中…",
  "to": "宛先",
  "subject": "件名",
  "message": "メッセージ",
  "completeNote": "ステータスは、このメールが送信された場合にのみ <b>Complete</b> に変わります。キャンセルすると何も変わりません。",
  "sending": "送信中…",
  "sendMarkComplete": "送信して Complete にする",
  "dupTitle": "重複の可能性",
  "dupLead": "この<b>シーズン + パートナー / ライン</b>のプロジェクトがすでに存在します：",
  "dupHint": "同じパートナー・シーズンで並行してプロジェクトを進めることはあります。これは警告であり、作成を妨げるものではありません。",
  "createAnyway": "このまま作成",
  "msg": {
    "deletingProject": "プロジェクトを削除中...",
    "groupDeleted": "{{id}} を削除しました — SKU {{skus}}件を削除、サンプルラウンド{{rounds}}件はプロジェクトなしで保持されます",
    "ticketsCancelled": " · チケット{{n}}件をキャンセル",
    "ticketsCancelledNotified": " · チケット{{n}}件をキャンセル、メールボックス{{m}}件に通知",
    "advanceCancelled": "キャンセルしました - {{id}} は Advance に設定されず、新しいラウンドも作成されていません",
    "theRound": "ラウンド",
    "photosAttached_one": " — 写真{{count}}枚を{{base}}に添付しました",
    "photosAttached_other": " — 写真{{count}}枚を{{base}}に添付しました",
    "theBaseId": "Base ID",
    "advanceSaved": "{{from}} を Advance に設定し、{{to}} を作成しました",
    "roundUpdated": "ラウンドを更新しました",
    "roundAdded": "ラウンドを追加しました",
    "renamed_one": "{{id}} の名前を「{{name}}」に変更しました（{{count}}ラウンド）",
    "renamed_other": "{{id}} の名前を「{{name}}」に変更しました（{{count}}ラウンド）",
    "confirmDeleteRound": "ラウンド {{id}} を削除しますか？この操作は元に戻せません。",
    "roundDeleted": "ラウンドを削除しました",
    "addPartnerFailed": "パートナーの追加に失敗しました",
    "partnerAdded": "パートナー「{{name}}」をリストに追加しました",
    "addSalesRepFailed": "Sales Rep の追加に失敗しました",
    "salesRepAdded": "Sales Rep「{{name}}」をリストに追加しました",
    "mailSent": " — 承認依頼を{{to}}に送信しました",
    "mailFailed": " — 承認メールの送信に失敗しました（{{err}}）",
    "mailPending": " — Pending Approval になりました。承認者にはまだ送信されていません。Project Approval を開き、「提出」を押してください。",
    "photosNotUploaded_one": " — 警告：写真{{count}}枚がアップロードされていません。編集から各 SKU に追加してください",
    "photosNotUploaded_other": " — 警告：写真{{count}}枚がアップロードされていません。編集から各 SKU に追加してください",
    "photosUploaded_one": " — 写真{{count}}枚をアップロードしました",
    "photosUploaded_other": " — 写真{{count}}枚をアップロードしました",
    "photosPartial": " — 警告：{{wanted}}枚中{{done}}枚のみアップロードされました。残りは SKU に追加してください",
    "movedInApproved_one": " · 承認済み SKU {{count}}件を移動しました — プロジェクトは Approved です",
    "movedInApproved_other": " · 承認済み SKU {{count}}件を移動しました — プロジェクトは Approved です",
    "notMovedRetry": " — 移動できませんでした：{{list}}。編集からプロジェクトを開いて、再度お試しください。",
    "newSkus_one": "（新規 SKU {{count}}件）",
    "newSkus_other": "（新規 SKU {{count}}件）",
    "createdPending": "{{id}} を Pending Approval として作成しました",
    "created": "{{id}} を作成しました",
    "newTicketN": "新しいチケット #{{n}}",
    "removeSkuFailed": "グループからの SKU の削除に失敗しました",
    "skuRemovedFrom": "{{id}} を {{group}} から削除しました",
    "ticketWord": "チケット",
    "ticketsEmailed": " · チケット{{n}}件をメール送信",
    "emailNotSent": " · メール未送信 — {{list}}",
    "createTicketFailed": "チケット {{code}} の作成に失敗しました",
    "ticketsAddedTo_one": "チケット{{count}}件を{{id}}に追加しました",
    "ticketsAddedTo_other": "チケット{{count}}件を{{id}}に追加しました",
    "noNewTicket": "追加する新しいチケットはありません",
    "refusedBefore": "この保存は、何も書き込まれる前に拒否されました。",
    "updateFailed": "{{id}} の更新に失敗しました",
    "updateTicketFailed": "チケット {{id}} の更新に失敗しました",
    "addSkuFailed": "SKU の追加に失敗しました",
    "skuMovedIn": " · SKU {{n}}件を移動しました",
    "notMoved": " — 移動できませんでした：{{list}}",
    "groupUpdated": "グループを更新しました",
    "skusUpdated": " · SKU {{n}}件を更新しました",
    "ticketsUpdated": " · チケット{{n}}件を更新しました",
    "skusAdded": " · SKU {{n}}件を追加しました",
    "ticketsAdded": " · チケット{{n}}件を追加しました",
    "previewFailed": "プレビューを作成できませんでした",
    "completeOpenFailed": "完了ダイアログを開けませんでした：{{err}}",
    "completeFailed": "プロジェクトを完了できませんでした",
    "completed": "{{id}} を Complete にしました — メールを{{to}}に送信しました",
    "exportedProjects": "Excel をエクスポートしました — プロジェクト{{groups}}件、SKU {{skus}}件",
    "exportedTickets": "Excel をエクスポートしました — チケット{{n}}件",
    "exported": "Excel をエクスポートしました",
    "noRowsExport": "エクスポートする行がありません",
    "projectUpdated": "プロジェクトを更新しました",
    "projectAdded": "プロジェクトを追加しました",
    "createGroupFailed": "グループの作成に失敗しました",
    "confirmDeleteProject": "プロジェクト {{id}} を削除しますか？この操作は元に戻せません。",
    "projectDeleted": "プロジェクトを削除しました",
    "ticketSavedMailFailed": "チケットは保存されましたが、メールの送信に失敗しました：{{err}}",
    "ticketSavedSent": "チケットを保存し、メールを送信しました",
    "ticketSaved": "チケットを保存しました",
    "ticketDeletedNotified": "{{id}} を削除しました — キャンセル通知を{{to}}に送信しました",
    "ticketDeletedMailFailed": "{{id}} を削除しました — 警告：キャンセルメールの送信に失敗しました。手動でお知らせください",
    "ticketDeletedNeverEmailed": "{{id}} を削除しました（メール送信されたことがないため、誰にも通知されていません）",
    "reminderSentTo": "リマインダーを{{to}}に送信しました",
    "emailSent": "メールを送信しました",
    "remindFailedPlain": "リマインダーを送信できませんでした",
    "reminderFor": "{{id}} のリマインダーを{{to}}に送信しました。",
    "reminderFailed": "リマインダーの送信に失敗しました：{{err}}",
    "sendTicketFailed": "チケットのメールを送信できませんでした"
  },
  "xls": {
    "titleProjects": "Helinox - プロジェクトトラッカー",
    "titleTickets": "Helinox - Ticket Station",
    "titleSamples": "Helinox - 全サンプル",
    "status": "ステータス：{{v}}",
    "team": "チーム：{{v}}",
    "owner": "オーナー：{{v}}",
    "developer": "デベロッパー：{{v}}",
    "designer": "デザイナー：{{v}}",
    "salesRep": "Sales Rep：{{v}}",
    "search": "検索：{{v}}",
    "card": "カード：{{v}}",
    "requester": "依頼者：{{v}}",
    "sopTeam": "Sales OP チーム：{{v}}",
    "receivingTeam": "受信チーム：{{v}}",
    "priority": "優先度：{{v}}",
    "sample": "サンプル：{{v}}",
    "round": "ラウンド：{{v}}",
    "location": "所在地：{{v}}",
    "allLocations": "すべての所在地",
    "sampleFinish": "サンプル仕上がり",
    "qty": "数量"
  }
};

const dictionary = { ns: 'stx', en, ko, vi, zh, fr, ja };

export default dictionary;
